export const SIX_MINUTE_WALK_SESSION_STORAGE_PREFIX = "pdx.sixMinuteWalk.v1";

export function buildSixMinuteWalkSessionStorageKey(uid) {
  return `${SIX_MINUTE_WALK_SESSION_STORAGE_PREFIX}:${uid || "anonymous"}`;
}

export function readStoredSixMinuteWalkAssessment(uid) {
  if (!uid || typeof window === "undefined") {
    return null;
  }

  try {
    const raw = window.sessionStorage.getItem(
      buildSixMinuteWalkSessionStorageKey(uid),
    );
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function writeStoredSixMinuteWalkAssessment(uid, value) {
  if (!uid || typeof window === "undefined") {
    return;
  }

  try {
    if (!value) {
      window.sessionStorage.removeItem(
        buildSixMinuteWalkSessionStorageKey(uid),
      );
      return;
    }

    window.sessionStorage.setItem(
      buildSixMinuteWalkSessionStorageKey(uid),
      JSON.stringify(value),
    );
  } catch {}
}

export function clearStoredSixMinuteWalkAssessment(uid) {
  writeStoredSixMinuteWalkAssessment(uid, null);
}
